import { useEffect } from 'react';
import { useLang } from 'hooks/lang';

import { Button, Column } from 'components/Blocks';

import SingleNotification from './SingleNotifications';

import { useNotification } from 'providers/Notifications';
import { scrollToWrapperTop } from 'utils/html';

function Notifications() {
  const {
    notifications,
    loadingMoreNotifications,
    noMoreNotifications,
    fetchMoreOldNotifications,
  } = useNotification();

  const { t } = useLang();

  useEffect(scrollToWrapperTop, []);

  return (
    <Column>
      <h2 className="text-2xl uppercase text-primary">{t('my-notifications')}</h2>

      {!notifications.length ? (
        <p className="text-center">{t('no-notifications-found')}</p>
      ) : (
        <>
          {notifications.map((notification, index) => (
            <SingleNotification key={notification.id} index={index} notification={notification} />
          ))}

          {!noMoreNotifications && (
            <Button
              onClick={fetchMoreOldNotifications}
              loading={loadingMoreNotifications}
              className="mx-auto"
            >
              {t('load-more')}
            </Button>
          )}
        </>
      )}
    </Column>
  );
}

export default Notifications;
